import React, { useState } from 'react';
import { Box, IconButton, Popper, useMediaQuery,useTheme} from "@mui/material";
import Calendar from "react-multi-date-picker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const SingleDateRangeFilter = ({ onDateRangeChange, label = "Date Range" }) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [anchorEl, setAnchorEl] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:800px)");

  const handleDateChange = (dates) => {
    const start = dates && dates[0] ? dates[0].toDate() : null;
    const end = dates && dates[1] ? dates[1].toDate() : null;
    
    setDateRange([start, end]);
    if (isSmallScreen && start && end) {
      setAnchorEl(null);
    }// close after selecting
    onDateRangeChange?.(start, end);
  };

  const handleIconClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "calendar-popper" : undefined;
  const theme = useTheme();

  return (
    <Box
      sx={{
        // minWidth: 120,
        // width: "100%",
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {isSmallScreen ? (
        <>
          <IconButton
            aria-describedby={id}
            onClick={handleIconClick}
            color="primary"
            sx={{
              backgroundColor: "transparent",
              borderRadius: "5px",
            }}
          >
            <CalendarMonthIcon />
          </IconButton>

          <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            sx={{
              zIndex: 1300,
              mt: 1,
            }}
          >
            <Box
              sx={{
                // backgroundColor: "white",
                // borderRadius: "5px",
                // boxShadow: 3,
                // border: "1px solid #CED4DA",
                p: 1,
              }}
            >
              <Calendar
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  fontSize: "12px",
                  // border: "solid 1px #CED4DA",
                  width: "250px",
                  backgroundColor: theme.palette.background.paper,
                  color:theme.palette.background.text,
                  borderRadius: "5px",
                }}  
                placeholder="Select Date Range"
                value={dateRange}
                format="DD/MM/YYYY"
                onChange={handleDateChange}
                range
                rangeHover
              />
            </Box>
          </Popper>
        </>
      ) : (
        <Calendar
          style={{
            padding: "10px",
            textAlign: "center",
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "12px",
            border: "solid 1px #CED4DA",
            width: "100%",
            maxWidth: "100vw",
            backgroundColor: theme.palette.background.paper,
            height: "100%",
            borderRadius: "5px",
          }}
          placeholder="Select Date Range"
          value={dateRange}
          format="DD/MM/YYYY"
          onChange={handleDateChange}
          range
          rangeHover
        />
      )}
    </Box>
  );
};

export default SingleDateRangeFilter;